import React, { useState, useMemo } from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DUMMY_EMPLOYEES } from '@/components/zoho/proto/dummyData';
import ProtoKPICards from '@/components/zoho/proto/ProtoKPICards';
import ProtoFilterBar from '@/components/zoho/proto/ProtoFilterBar';
import ProtoEntityCards from '@/components/zoho/proto/ProtoEntityCards';
import ProtoSubmissionTable from '@/components/zoho/proto/ProtoSubmissionTable';
import ProtoDetailSheet from '@/components/zoho/proto/ProtoDetailSheet';

export default function ProtoSubmissionsPage() {
  var viewState = useState('grid');
  var viewMode = viewState[0];
  var setViewMode = viewState[1];

  var searchState = useState('');
  var search = searchState[0];
  var setSearch = searchState[1];

  var deptState = useState('all');
  var dept = deptState[0];
  var setDept = deptState[1];

  var ratingState = useState('all');
  var rating = ratingState[0];
  var setRating = ratingState[1];

  var monthState = useState('all');
  var month = monthState[0];
  var setMonth = monthState[1];

  var selectedState = useState(null);
  var selected = selectedState[0];
  var setSelected = selectedState[1];

  var filtered = useMemo(function() {
    var result = DUMMY_EMPLOYEES;
    if (search) {
      var q = search.toLowerCase();
      result = result.filter(function(e) {
        return e.name.toLowerCase().includes(q) || e.empId.includes(q);
      });
    }
    if (dept !== 'all') {
      result = result.filter(function(e) { return e.department === dept; });
    }
    if (rating !== 'all') {
      var minRating = parseInt(rating);
      result = result.filter(function(e) { return parseInt(e.overallRating) >= minRating; });
    }
    if (month !== 'all') {
      result = result.filter(function(e) {
        if (!e.lastSubmission) return false;
        var d = new Date(e.lastSubmission);
        var ym = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0');
        return ym === month;
      });
    }
    return result;
  }, [search, dept, rating, month]);

  return (
    <div className="min-h-screen bg-slate-50" data-testid="proto-submissions-page">
      <div className="max-w-[1600px] mx-auto p-6 space-y-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Button variant="ghost" size="icon" className="h-8 w-8" data-testid="proto-back-btn">
              <ArrowLeft className="h-4 w-4" />
            </Button>
            <div>
              <h1 className="text-2xl font-bold tracking-tight">Appraisal Form Submissions</h1>
              <p className="text-sm text-muted-foreground">Annual Performance Review 2024 &middot; Zylker Corp</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-xs text-muted-foreground bg-amber-50 text-amber-700 border border-amber-200 rounded-full px-3 py-1 font-medium">
              STATIC PROTOTYPE
            </span>
          </div>
        </div>

        <ProtoKPICards />

        <ProtoFilterBar
          viewMode={viewMode}
          onViewChange={setViewMode}
          search={search}
          onSearch={setSearch}
          dept={dept}
          onDept={setDept}
          rating={rating}
          onRating={setRating}
          month={month}
          onMonth={setMonth}
        />

        <div>
          <div className="flex items-center justify-between mb-3">
            <p className="text-sm text-muted-foreground">
              Showing <span className="font-semibold text-slate-700">{filtered.length}</span> of {DUMMY_EMPLOYEES.length} employees
            </p>
          </div>

          {viewMode === 'grid' ? (
            <ProtoEntityCards onSelect={setSelected} filtered={filtered} />
          ) : (
            <ProtoSubmissionTable onSelect={setSelected} filtered={filtered} />
          )}
        </div>

        <ProtoDetailSheet
          emp={selected}
          open={selected !== null}
          onClose={function() { setSelected(null); }}
        />
      </div>
    </div>
  );
}
